import { render, staticRenderFns } from "./ProfileVideo.vue?vue&type=template&id=f64cb352&"
import script from "./ProfileVideo.vue?vue&type=script&lang=js&"
export * from "./ProfileVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports